module.exports = __webpack_public_path__ + "static/media/nyan-cat.b311b2f8.gif";